import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Temoignage() {
  const { t } = useTranslation('reparation');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="temoignage" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Image */}
          <div
            className={`order-2 lg:order-1 transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20restored%20Quebec%20bungalow%20house%20with%20new%20asphalt%20shingle%20roof%20in%20spring%2C%20bright%20blue%20sky%2C%20lush%20green%20lawn%2C%20warm%20golden%20hour%20light%2C%20architectural%20photography%2C%20residential%20neighborhood%2C%20Canada&width=800&height=600&seq=rep3&orientation=landscape"
                alt="Maison avec toiture réparée après infiltration d'eau à Lévis par couvreur RBQ"
                className="w-full h-64 md:h-96 object-cover object-top"
                loading="lazy"
                width="800"
                height="600"
                width="800"
                height="600"
              />
            </div>
          </div>

          {/* Texte */}
          <div
            className={`order-1 lg:order-2 transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="flex items-center gap-1 mb-5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-copper text-lg" />
              ))}
            </div>

            <blockquote className="text-slate-primary/80 text-base md:text-lg leading-relaxed mb-6">
              "{t('temoin_text')}"
            </blockquote>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-slate-primary flex items-center justify-center text-white font-bold text-sm">
                RD
              </div>
              <div>
                <p className="font-manrope font-bold text-slate-primary text-sm">{t('temoin_name')}</p>
                <p className="text-slate-primary/50 text-xs">
                  {t('temoin_location')} — {t('temoin_project')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-slate-primary/40 text-xs mt-8 text-center italic max-w-3xl mx-auto">
        Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
      </p>
    </section>
  );
}